import React from "react";
import { instructionRegistry } from "../content/instructions";

export default function InstructionsHost({ testKey }) {
    const Instr = instructionRegistry[testKey] || instructionRegistry.writing;
    return <Instr />;
}
